import { appendQueryParams } from './appendQueryParams';
import { logger } from './logger';

export type SessionTerminationStatus =
  | 'SESSION_EXPIRED'
  | 'MAX_ATTEMPTS_REACHED';

interface SessionTerminationParams {
  agentReturnUrl?: string;
  paymentId: string;
  status: SessionTerminationStatus;
  sessionId: string;
}

export function handleSessionTermination({
  agentReturnUrl,
  paymentId,
  status,
  sessionId,
}: SessionTerminationParams): void {
  if (agentReturnUrl && agentReturnUrl.trim() !== '') {
    const fullUrl = appendQueryParams(agentReturnUrl, { paymentId });
    logger.info('Session terminated — redirecting to agentReturnUrl', {
      sessionId,
      status,
      fullUrl,
    });
    window.location.href = fullUrl;
  } else {
    logger.info('Session terminated — emitting postMessage', {
      sessionId,
      status,
    });
    window.parent.postMessage(
      {
        eventName: 'payment-outcome',
        type: 'payment.completed',
        payload: {
          paymentId,
          status,
          timestamp: new Date().toISOString(),
        },
      },
      '*'
    );
  }
}
